module.exports = __webpack_public_path__ + "img/female-dev.daf91437.svg";